import React, { useState, useEffect } from "react";
import grey from "@material-ui/core/colors/grey";
import { FilterComponentObj } from "../FilterComponents/FilterComponentObj";
import {
    withStyles,
    makeStyles,
    createStyles,
    useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";
import { reportFilterLube } from "./ReportObj"
import { ToastError } from "../../services/ToastMsg";
import { getRequest, postRequest } from "../../services/ApiServices";
import { getCookie } from "../../services/Cookies";
import FilterComponents from "../FilterComponents/FilterComponents";

export default function FiltersReportLube(props) {
    const theme = useTheme();
    const [shipNameData, setShipNameData] = useState([]);
    const [shipNamesMultipleSelect, setShipNamesMultipleSelect] = useState([]);
    const [customerNamesMultipleSelect, setCustomerNamesMultipleSelect] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    const [formObj, setFormObj] = useState(reportFilterLube);
    const [filtercomObj, setfiltercomObj] = React.useState(FilterComponentObj);
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
  
    const { filterReportLube, clearFilter,FormatClearFilter } = props;

    const applyFilter = (Obj) => { 
        filterReportLube(Obj);
        FormatClearFilter(Obj);
         console.log(formObj); };

    const onClearFilter = (Obj) => {
        setShipNamesMultipleSelect([]);
        setCustomerNamesMultipleSelect([]);
        filterReportLube(Obj);
        FormatClearFilter(Obj)
        clearFilter();

    }

    const fetchShipNameData = async () => {

        const customerKey = getCookie("clientId");
        //const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/${customerKey}`;
        //const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/LubeAnalysis/ReportStatus/DrillDown/Filter`;
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/Filter`;
        var token = getCookie("token");
        const options = {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        };
        //await getRequest(url).
        await postRequest(url, {}, options)
            .then((res) => {
                console.log("fetchShipNameData DrillDown/Filter :", '\n', url, res.data);
                if (res.status == 200) {
                    //  dispatch({ type: LOADING, payload: false });
                    setShipNameData(res.data);
                    //console.log(shipNameData);
                } else {
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                // dispatch({ type: LOADING, payload: false });
                //console.log(error);
                // ToastError(error.response.data.message);
            });
    }
    const getCustomerData = async () => {
        // dispatch({ type: LOADING, payload: true });
        const url =
            process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
            `Customer`;
        await getRequest(url)
            .then((res) => {
                //console.log(res);
                if (res.status == 200) {

                    setCustomerData(res.data);
                } else {
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
            });
    };

    const defaultValue = (val) => {
        //
        if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setfiltercomObj(Obj);
            console.log('getcookievalue', formObj)
        }
    }
    useEffect(() => {
        fetchShipNameData();
        getCustomerData();
        defaultValue(GlobalFilterSettingValue);

    }, []);
    return (
        <div>
         <Box className="decarbox1" component="div" style={{padding: "20px"}}  >
            
         
            <FilterComponents screen={"reports"} defaultDate={props.defaultDate} filtervalue={["CustomerName","ShipName_imo","LoBrand","LoGrade","EquipName","EquipMake","EquipModel","Lab_Lube","LubeReportDateComponent","Service_type"]} applyFilter={applyFilter} reset={onClearFilter} />

        </Box>


        </div>
    );
}

